/* ------------------------------------------------------------------------
   Search results page. search.results/search.filters are bound server-side
   (see sections/kc-search-results.liquid); this file handles: the search
   field's clear button, tabs, sort menu, the filter drawer (open/close +
   apply/clear via plain navigation, no fetch), the client-side "show more"
   reveal for products beyond the first 24 (all of them are already in the
   DOM from one server-side paginate — no extra request), and wiring up
   kc-plp.js's wishlist/quick-add for cards rendered outside a
   [data-kc-plp-section] wrapper.
   ------------------------------------------------------------------------ */
(function () {
	var root = document.querySelector('[data-kc-search-results-page]');
	if (!root) return;

	function qsa(scope, selector) {
		return Array.prototype.slice.call(scope.querySelectorAll(selector));
	}

	if (window.kcPlpCards) {
		qsa(root, '[data-kc-search-products-grid]').forEach(function (grid) {
			window.kcPlpCards.init(grid);
		});
	}

	// --- Search field: clear button ---------------------------------------------
	var input = root.querySelector('[data-kc-search-input]');
	var clearButton = root.querySelector('[data-kc-search-clear]');

	if (input && clearButton) {
		function syncClear() {
			clearButton.hidden = input.value.trim() === '';
		}
		input.addEventListener('input', syncClear);
		clearButton.addEventListener('click', function () {
			input.value = '';
			syncClear();
			input.focus();
		});
	}

	// --- Products grid: reveal the rest client-side (already rendered) ----------
	var loadMoreButton = root.querySelector('[data-kc-search-loadmore-button]');
	if (loadMoreButton) {
		loadMoreButton.addEventListener('click', function () {
			var grid = root.querySelector('[data-kc-search-products-grid]');
			var loadMore = root.querySelector('[data-kc-search-loadmore]');
			var fill = root.querySelector('[data-kc-search-loadmore-fill]');
			var count = root.querySelector('[data-kc-search-loadmore-count]');
			var total = loadMoreButton.getAttribute('data-total');
			if (grid) grid.removeAttribute('data-collapsed');
			if (fill) fill.style.width = '100%';
			if (count) count.textContent = ((window.KC_I18N && KC_I18N.showingCount) || 'Showing [[shown]] of [[total]]').replace('[[shown]]', total).replace('[[total]]', total);
			if (loadMore) loadMore.hidden = true;
		});
	}

	// --- Tabs ------------------------------------------------------------------
	var tabs = qsa(root, '[data-kc-search-tab]');
	tabs.forEach(function (tab) {
		tab.addEventListener('click', function () {
			var target = tab.getAttribute('data-kc-search-tab');
			tabs.forEach(function (t) {
				var isActive = t === tab;
				t.classList.toggle('is-active', isActive);
				t.setAttribute('aria-selected', isActive ? 'true' : 'false');
			});
			qsa(root, '[data-kc-search-panel]').forEach(function (panel) {
				panel.hidden = panel.getAttribute('data-kc-search-panel') !== target;
			});

			var url = new URL(window.location.href);
			url.searchParams.set('tab', target);
			window.history.replaceState({}, '', url);
		});
	});

	// --- Sort menu ---------------------------------------------------------------
	var sortToggle = root.querySelector('[data-kc-search-sort-toggle]');
	var sortMenu = root.querySelector('[data-kc-search-sort-menu]');

	if (sortToggle && sortMenu) {
		function closeSort() {
			sortMenu.hidden = true;
			sortToggle.setAttribute('aria-expanded', 'false');
		}
		sortToggle.addEventListener('click', function () {
			var isOpen = !sortMenu.hidden;
			sortMenu.hidden = isOpen;
			sortToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
		});
		document.addEventListener('click', function (event) {
			if (sortMenu.hidden) return;
			if (sortToggle.contains(event.target) || sortMenu.contains(event.target)) return;
			closeSort();
		});
		document.addEventListener('keydown', function (event) {
			if (event.key === 'Escape' && !sortMenu.hidden) {
				closeSort();
				sortToggle.focus();
			}
		});
	}

	// --- Filter drawer shell (open/close only — no real filters yet) -------------
	var filterOpenButton = root.querySelector('[data-kc-filter-open]');
	var drawer = document.querySelector('[data-kc-filter-drawer]');

	if (filterOpenButton && drawer) {
		var backdrop = drawer.querySelector('[data-kc-filter-drawer-backdrop]');
		var closeButton = drawer.querySelector('[data-kc-filter-drawer-close]');

		function openDrawer() {
			drawer.hidden = false;
			requestAnimationFrame(function () {
				drawer.classList.add('is-open');
			});
			document.body.style.overflow = 'hidden';
		}

		function closeDrawer() {
			drawer.classList.remove('is-open');
			document.body.style.overflow = '';
			window.setTimeout(function () {
				drawer.hidden = true;
			}, 200);
			filterOpenButton.focus();
		}

		filterOpenButton.addEventListener('click', openDrawer);
		if (backdrop) backdrop.addEventListener('click', closeDrawer);
		if (closeButton) closeButton.addEventListener('click', closeDrawer);
		document.addEventListener('keydown', function (event) {
			if (event.key === 'Escape' && !drawer.hidden) closeDrawer();
		});

		// Apply/clear reload the page with the chosen filter params — a plain
		// navigation (same mechanism as the sort links), not a fetch call.
		var applyButton = drawer.querySelector('[data-kc-filter-drawer-apply]');
		var drawerClearButton = drawer.querySelector('[data-kc-filter-drawer-clear]');
		var currentQuery = (new URLSearchParams(window.location.search)).get('q') || '';

		if (applyButton) {
			applyButton.addEventListener('click', function () {
				var params = new URLSearchParams();
				params.set('q', currentQuery);
				qsa(drawer, '[data-kc-filter-input]:checked').forEach(function (checkbox) {
					params.append(checkbox.name, checkbox.value);
				});
				var priceMin = drawer.querySelector('[data-kc-filter-price-min]');
				var priceMax = drawer.querySelector('[data-kc-filter-price-max]');
				if (priceMin && priceMin.value) params.set(priceMin.getAttribute('data-param'), priceMin.value * 100);
				if (priceMax && priceMax.value) params.set(priceMax.getAttribute('data-param'), priceMax.value * 100);
				window.location.href = window.location.pathname + '?' + params.toString();
			});
		}

		if (drawerClearButton) {
			drawerClearButton.addEventListener('click', function () {
				window.location.href = window.location.pathname + '?q=' + encodeURIComponent(currentQuery);
			});
		}
	}
})();
